import { z } from 'zod';
/** Clinical trackers (v2.0, Phase 16) — Eligibility + Authorizations. */
export const ELIGIBILITY_STATUSES = ['active', 'terminated', 'pending', 'unknown'];
export const AUTH_STATUSES = ['requested', 'approved', 'denied', 'expired', 'exhausted'];
export const eligibilityCreateSchema = z.object({
    checkedAt: z.coerce.date().optional(),
    payer: z.string().min(1).max(120),
    memberId: z.string().max(120).optional(),
    planName: z.string().max(120).optional(),
    groupNum: z.string().max(60).optional(),
    deductibleMet: z.boolean().optional(),
    oopMet: z.boolean().optional(),
    copay: z.string().max(40).optional(),
    coinsurance: z.string().max(40).optional(),
    status: z.enum(ELIGIBILITY_STATUSES).default('unknown'),
    method: z.string().max(40).optional(),
    notes: z.string().max(2000).optional(),
});
export const authorizationCreateSchema = z
    .object({
    authNo: z.string().min(1).max(80),
    payer: z.string().min(1).max(120),
    serviceType: z.string().max(120).optional(),
    cptCodes: z.array(z.string().max(12)).max(40).optional(),
    diagnosis: z.string().max(120).optional(),
    frequency: z.string().max(80).optional(),
    priorAuthRequired: z.boolean().optional(),
    dateAuthorized: z.coerce.date().optional(),
    requestingProvider: z.string().max(160).optional(),
    referringProvider: z.string().max(160).optional(),
    unitsAuthorized: z.string().max(40).optional(),
    sessionsApproved: z.number().int().min(0).max(9999).optional(),
    startsOn: z.coerce.date().optional(),
    expiresOn: z.coerce.date().optional(),
    method: z.string().max(40).optional(),
    status: z.enum(AUTH_STATUSES).default('requested'),
    notes: z.string().max(2000).optional(),
})
    // ehr#354: no impossible date range.
    .refine((a) => !a.startsOn || !a.expiresOn || a.expiresOn >= a.startsOn, {
    path: ['expiresOn'],
    message: 'The Expiry Date must be on or after the Effective Date.',
});
export const authorizationUpdateSchema = z.object({
    // ehr#365: Edit can correct the auth number and payer too.
    authNo: z.string().min(1).max(80).optional(),
    payer: z.string().min(1).max(120).optional(),
    status: z.enum(AUTH_STATUSES).optional(),
    serviceType: z.string().max(120).nullable().optional(),
    cptCodes: z.array(z.string().max(12)).max(40).nullable().optional(),
    diagnosis: z.string().max(120).nullable().optional(),
    frequency: z.string().max(80).nullable().optional(),
    priorAuthRequired: z.boolean().nullable().optional(),
    dateAuthorized: z.coerce.date().nullable().optional(),
    requestingProvider: z.string().max(160).nullable().optional(),
    referringProvider: z.string().max(160).nullable().optional(),
    unitsAuthorized: z.string().max(40).nullable().optional(),
    sessionsApproved: z.number().int().min(0).max(9999).nullable().optional(),
    startsOn: z.coerce.date().nullable().optional(),
    expiresOn: z.coerce.date().nullable().optional(),
    method: z.string().max(40).nullable().optional(),
    notes: z.string().max(2000).nullable().optional(),
});
// Phase 16b — Licensure / credentialing.
export const LICENSE_TYPES = [
    'pre_licensed',
    'lpc_lpcc',
    'lcsw_lmsw',
    'lmft',
    'psychologist',
    'psychiatrist',
    'rn_lpn',
    'none',
    'other',
];
export const licensureCreateSchema = z.object({
    licenseType: z.enum(LICENSE_TYPES).default('other'),
    licenseNumber: z.string().max(80).optional(),
    licenseState: z.string().max(40).optional(),
    npi: z.string().max(20).optional(),
    taxonomy: z.string().max(40).optional(),
    issuedOn: z.coerce.date().optional(),
    expiresOn: z.coerce.date().optional(),
    ceuRequired: z.number().int().min(0).max(9999).optional(),
    ceuCompleted: z.number().int().min(0).max(9999).optional(),
    credentialingStatus: z.string().max(120).optional(),
    caqhId: z.string().max(40).optional(),
    notes: z.string().max(2000).optional(),
});
export const licensureUpdateSchema = licensureCreateSchema.partial();
//# sourceMappingURL=clinical.js.map